module.exports = __webpack_public_path__ + "static/media/FrX_lZQaUAEV7oX.9af2b5fb.webp";